import {clearA360CommissionsState} from 'Agent/Commissions/ducks/a360Commissions';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import '../DataDashboard/Commissions.scss';
import {CommissionReportFilter} from './CommissionsReportFilter';
import './CommissionsReporting.scss';
import {CommissionsReportToRender} from './CommissionsReports';
import {ExportReportToCSV} from './ExportReportToCSV';
import { clearA360CommissionsReportingState } from 'Agent/Commissions/ducks/a360CommissionsReport';

export const CommissionReportingView = ({isNewYork}: {isNewYork: boolean}) => {
  const {
    filter: {selectedProducerCodes},
  } = useSelector((state: ReducerState) => state.a360CommissionsReport);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearA360CommissionsReportingState());
    };
  }, []);

  return (
    <main className="a360_commissions_reporting-grid">
      <CommissionReportFilter isNewYork={isNewYork} />
      {selectedProducerCodes.length > 0 && (
        <>
          <CommissionsReportToRender />
          <ExportReportToCSV />
        </>
      )}
    </main>
  );
};
